var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    {
      staticClass: "w-full",
      attrs: { id: _vm.id, options: _vm.options, title: "Import from IMDb" }
    },
    [
      _c(
        "p",
        { staticClass: "mb-3 text-gray-700 leading-relaxed" },
        [
          _vm._v(
            " At the moment, importing data from IMDb is limited given their "
          ),
          _c(
            "BaseLink",
            { attrs: { url: "https://www.imdb.com/interfaces/" } },
            [_vm._v(" lack of APIs ")]
          ),
          _vm._v(". ")
        ],
        1
      ),
      _c("p", { staticClass: "mb-4 text-gray-700 leading-relaxed" }, [
        _vm._v(
          " For now, you can introduce a text containing movie urls from imdb.com and they will be added to your collection. "
        )
      ]),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.text,
            expression: "text"
          }
        ],
        staticClass:
          "\n            rounded shadow-xs p-2 bg-blue-100 border border-blue-200 placeholder-gray-600\n            mb-4 focus:border-blue-300\n        ",
        attrs: { rows: "10", placeholder: _vm.textareaPlaceholder },
        domProps: { value: _vm.text },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.text = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "BaseButton",
        {
          staticClass:
            "bg-blue-500 text-white font-semibold justify-center hover:bg-blue-700",
          on: { click: _vm.submit }
        },
        [_vm._v(" Import Movies ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }